<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Grievance Registration Form</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Grievance Registration Form</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="grievance-form ptb--100 horizontal--tab">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-9">
        <form [formGroup]="grievanceForm" (ngSubmit)="submitForm()">
          <div class="row">
            <div class="col-md-6 pb-3" id="category-field">
              <label for="">Category<span class="error">*</span></label><br>
              <div class="form-group form-check-inline form-radio">
                <input type="radio" formControlName="category" id="student" value="student"
                  class="student"><span>Student</span>
              </div>
              <div class="form-group form-check-inline form-radio">
                <input type="radio" formControlName="category" id="staff" value="staff" class="staff"><span>Staff</span>
              </div>
            </div>
            <div class="col-md-6 pb-3" id="subject-field">
              <label for="form-name">Name<span class="error">*</span></label>
              <div class="form-group icon-position">
                <i class="fa fa-user" style="z-index: 1"></i>
                <input type="text" class="form-control" formControlName="name" placeholder="Enter Name"
                  [ngClass]="{ 'is-invalid' : submitted && f.name.errors  }">
              </div>
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">Name is required</div>
              </div>
            </div>
            <div class="col-md-6 pb-3" id="email">
              <label for="form-email">Email<span class="error">*</span></label>
              <div class="form-group icon-position">
                <i class="fa fa-envelope" style="z-index: 1"></i>
                <input type="email" class="form-control" formControlName="email" placeholder="Enter Email"
                  [ngClass]="{ 'is-invalid' : submitted && f.email.errors  }">
              </div>
              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
              </div>
            </div>
            <div class="col-md-6 pb-3" id="phone-field">
              <label for="phone-subject">Phone No.<span class="error">*</span></label>
              <div class="form-group icon-position">
                <i class="fa fa-phone" style="z-index: 1"></i>
                <input type="text" class="form-control" formControlName="phone" placeholder="Enter Mobile Number"
                  [ngClass]="{ 'is-invalid' : submitted && f.phone.errors  }">
              </div>
              <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                <div *ngIf="f.phone.errors.required">Mobile Number is required.</div>
                <div *ngIf="f.phone.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
              </div>
            </div>
            <div class="col-md-12 pb-3" id="category-field">
              <label for="">Program<span class="error">*</span></label>
              <select class="form-control" formControlName="program_name"
                [ngClass]="{ 'is-invalid' : submitted && f.program_name.errors  }">
                <option value="" [selected]=true [disabled]="true">Choose Programe...</option>
                <option value="UG">UG</option>
                <option value="PG">PG</option>
              </select>
            </div>
            <div class="col-md-6 pb-3" id="category-field">
              <label for="">Course<span class="error">*</span></label>
              <div id="coursediv">
                <select class="form-control" formControlName="course" style="width: 100%">
                  <option selected="true" disabled="true">-- select course --</option>
                  <option value="BBA">Bachelor of Business Administration</option>
                  <option value="BCom">Bachelor of Commerce</option>
                  <option value="BA">Bachelor of Arts</option>
                  <option value="BSC">Bachelor of Science</option>
                  <option value="M.Sc">M.Sc Computer Science</option>
                  <option value="M.Com">M.Com</option>
                </select>
              </div>

            </div>
            <div class="col-md-6 pb-3" id="department-field">
              <label for="form-department">Specialization<span class="error">*</span></label>
              <div class="form-group">
                <div id="specialdiv">
                  <select class="form-control" formControlName="specialization"
                    [ngClass]="{ 'is-invalid' : submitted && f.specialization.errors  }">
                    <option value="BBA(CA)">Bachelor of Business Administration (Computer Application)</option>
                    <option value="BBA">Bachelor of Business Administration</option>
                    <option value="BSC(CS)">B.Sc. Computer Science</option>
                    <option value="BCom">Bachelor of Commerce</option>
                    <option value="BA">Bachelor of Arts</option>
                    <option value="BSC">Bachelor of Science</option>
                    <option value="BSC(HS)">BSc Hospitality Studies</option>
                    <option value="BSC(HS)">M.Sc Computer Science</option>
                    <option value="BSC(HS)">M.Com</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6 pb-3" id="semester-field">
              <label for="form-semester">Semester <span class="error">*</span></label>
              <div class="form-group">
                <select class="form-control" formControlName="semester"
                  [ngClass]="{ 'is-invalid' : submitted && f.semester.errors  }">
                  <option value="" [selected]=true [disabled]="true">Choose Semester...</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
              </div>
            </div>
            <div class="col-md-6 pb-3" id="section-field">
              <label for="form-section">Section<span class="error">*</span></label>
              <div class="form-group">
                <select class="form-control" formControlName="section"
                  [ngClass]="{ 'is-invalid' : submitted && f.section.errors  }">
                  <option value="" [selected]=true [disabled]="true">Choose Section...</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                </select>
              </div>
            </div>
            <div class="col-md-12 pb-3" id="message-field">
              <label for="form-message">Message <span class="error">*</span></label>
              <div class="form-group">
                <textarea type="text" class="form-control" formControlName="message" placeholder="Grievance"
                  [ngClass]="{ 'is-invalid' : submitted && f.message.errors  }"></textarea>
              </div>

            </div>
            <!-- <div class="form-group col-md-3" style="float: left; padding-left: 20px">
                      <img src="captcha.php?rand=<?php echo rand(); ?>" id='captcha_image'>&emsp;
                      <a href='javascript: refreshCaptcha();'><i class="fa fa-refresh"></i></a>
                  </div>
                  <div class="form-group col-md-6" style="margin-top: 3px">
                      <input type="text" class="form-control" placeholder="Enter Captcha *" name="captcha" id="captcha" autocomplete="off" required>
                  </div>-->
            <div class="col-md-12 mt-4">
              <div class="form-group text-center">
                <button type="submit" class="cmn-button">Submit</button>
              </div>
            </div>
          </div>
        </form>
        <!-- <iframe src="https://ghrcacs.raisoni.net/php_pages/grievance_form.php" frameborder="0" width="100%" height="750px" allowtransparency = "true"></iframe> -->
      </div>
    </div>
  </div>
</section>
